
<router-outlet></router-outlet>

<!-- feature flag not work in signin page -->

<!-- @if (featureFlags.isEnabled('AI_TICKET')) {
  <div class="helper">
    <a (click)="openSupportTicket(); $event.preventDefault()" href="#">
      <img alt="Open a Support Ticket" title="Open a support ticket" src="/assets/images/help.png">
    </a>
  </div>
} @else {
  <div class="helper">
    <a href="https://pinnaclepowerservices.zohodesk.com/portal/en/newticket" target="_blank">
      <img alt="Open a Help Ticket" title="Open a help ticket" src="/assets/images/help.png">
    </a>
  </div>
} -->

 <div class="helper">
    <a (click)="openSupportTicket(); $event.preventDefault()" href="#">
      <img alt="Open a Support Ticket" title="Open a support ticket" src="/assets/images/help.png">
    </a>
  </div>